import * as React from 'react';

export function FullBodyKnelling1(props: React.SVGProps<SVGSVGElement>) {
	const uid = React.useId();

	const maskA = `${uid}-knelling1-mask-a`;
	const maskB = `${uid}-knelling1-mask-b`;

	const filter0 = `${uid}-knelling1-filter0`;
	const filter1 = `${uid}-knelling1-filter1`;
	const filter2 = `${uid}-knelling1-filter2`;

	const { style, ...rest } = props;

	return (
		<svg
			width={58}
			height={74}
			viewBox="0 0 58 74"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid meet"
			style={{ display: 'block', overflow: 'visible', ...style }}
			{...rest}
		>
			<path
				d="M37.715 64.87c.353.742.4 1.593.13 2.368a3.087 3.087 0 01-1.567 1.765 3.16 3.16 0 01-1.732.315 3.185 3.185 0 01-1.637-.659s-.01-.038-.053-.046l-.296-.304-.078-.065a13.784 13.784 0 00-1.92-1.464 14.732 14.732 0 00-3.883-1.658 74.643 74.643 0 01-7.717-2.786 29.586 29.586 0 01-4.68-2.58.49.49 0 01-.125-.072 6.532 6.532 0 01-.632-.46 5.6 5.6 0 01-1.597-1.959 5.986 5.986 0 01-.263-4.548 5.911 5.911 0 013.011-3.392 6.148 6.148 0 011.859-.575 6.798 6.798 0 014.213.989c2.36 1.24 3.676 2.491 6.375 4.806 3.748 3.207 3.575 2.839 5.322 4.483a55.32 55.32 0 014.903 5.243s.013.047.047.063c.127.166.234.346.32.536z"
				fill="#8C8C8C"
			/>
			<path
				d="M6.555 67.385c-.377-.58.025-1.39.239-1.796.213-.405.392-.565 1.703-1.876a9.214 9.214 0 011.162-1.125c.717-.503 1-.422 1.761-.879A6.45 6.45 0 0013 60.38c.84-.93.72-1.258 1.539-2.056.425-.474.971-.82 1.58-1.003a2.13 2.13 0 011.383.042c.596.264.87.853 1.405 2.02.231.512.435 1.036.61 1.57.118.27.273.522.462.748.195.19.37.4.52.628.123.29.154.611.087.917-.032.323-.14.633-.314.905a2.03 2.03 0 01-1.598.933 2.068 2.068 0 01-.943-.171 18.619 18.619 0 00-2.85.05c-.802.097-1.597.237-2.382.417a5.994 5.994 0 00-2.01.617c-.368.254-.722.53-1.057.828-1.253.983-1.509 1.095-1.826 1.084a1.23 1.23 0 01-.589-.13 1.257 1.257 0 01-.462-.394z"
				fill="#8C8C8C"
			/>
			<path
				d="M32.548 68.95a58.835 58.835 0 01-4.196-.749c-1.66-.352-2.509-.645-4.694-1.162-1.92-.477-3.583-.834-4.863-1.095l-.068-.004a2.07 2.07 0 01-1.25-.826 2.093 2.093 0 01-.372-1.457c.06-.515.31-.988.7-1.326.39-.339.891-.518 1.406-.503.136.009.25.05.371.067.977.14 1.96.22 2.946.241.9.072 1.806.013 2.689-.177.36-.095.759-.242 1.45-.4.467-.078.94-.124 1.415-.139 1.053-.037 3.237.338 5.927 1.381.738.18 1.387.622 1.827 1.246.44.623.64 1.386.566 2.145a3.16 3.16 0 01-.973 1.989 3.12 3.12 0 01-2.033.851c-.282-.002-.572-.045-.848-.081zM27.335 33.966c.133.703.341 2.359-2.452 9.71-1.405 3.694-1.86 4.316-2.111 6.214-.218 1.569-.19 3.163.083 4.722.03.291.093.554.136.8.044.246.036.357.038.54.005 1.628-.453 2.185-1.59 3.341a6.083 6.083 0 01-4.301 1.82 6.162 6.162 0 01-2.778-.593 6.206 6.206 0 01-2.224-1.778c-.295-.445-.745.1-.99-.376a10.88 10.88 0 01-1.38-5.668c.065-.948.256-1.882.568-2.778a22.49 22.49 0 011.33-2.66s.687-1.381 1.194-2.75c.506-1.368.613-2.49.723-5.706.155-4.595.078-5.37.156-6.15 0 0 .023-.338.09-.637.338-1.928 1.93-4.088 2.09-4.31 1.23-1.643 1.564-1.534 2.835-3.351a7.319 7.319 0 001.146-2.029c.577-1.825-.244-2.824.349-3.477.74-.815 2.825-.206 4.08.545 1.964 1.148 3.348 3.539 2.84 4.998-.11.401-.334.76-.644 1.035-.532.435-1.072.311-1.453.802a1.468 1.468 0 00-.274.776c-.095.942.595 1.374 1.285 2.668a14.847 14.847 0 011.254 4.292z"
				fill="#8C8C8C"
			/>
			<path
				d="M31.295 18.102c.023.938-.04 1.875-.186 2.801-.126.69-.297 1.37-.512 2.036a7.319 7.319 0 01-.947 2.243c-.221.39-.543.71-.93.929a2.765 2.765 0 01-2.156-.113 4.904 4.904 0 01-1.254-.747c-.552-.415-.611-.59-1.227-1.126a12.499 12.499 0 00-1.375-1.023c-1.225-.813-1.3-.604-1.91-1.094a5.108 5.108 0 01-1.61-2.417 7.01 7.01 0 01-.221-1.81 6.232 6.232 0 011.97-4.236 6.14 6.14 0 014.344-1.65 6.144 6.144 0 014.256 1.87 6.237 6.237 0 011.753 4.332l.005.005zM37.293 65.464c.355.756.394 1.621.108 2.408a3.191 3.191 0 01-1.637 1.791c-.555.27-1.175.38-1.79.316a3.285 3.285 0 01-1.681-.675s-.01-.038-.055-.047l-.302-.31-.08-.066a14.03 14.03 0 00-1.964-1.495 15.187 15.187 0 00-3.989-1.697 77.148 77.148 0 01-7.932-2.856 30.364 30.364 0 01-4.8-2.638.5.5 0 01-.128-.074 6.674 6.674 0 01-.647-.47 5.647 5.647 0 01-1.626-1.997 6.003 6.003 0 01-.223-4.627 6.111 6.111 0 013.145-3.442 6.45 6.45 0 011.923-.579 7.059 7.059 0 014.336 1.017c2.423 1.27 3.766 2.545 6.526 4.908 3.832 3.273 3.658 2.898 5.442 4.575a55.97 55.97 0 015.001 5.347s.013.049.048.065c.129.169.238.352.325.546z"
				fill="#BFBFBF"
			/>
			<path
				d="M5.01 69.448c-.358-.619.11-1.443.355-1.856.247-.412.442-.571 1.885-1.879.393-.41.82-.784 1.277-1.12.777-.493 1.068-.396 1.887-.839a6.887 6.887 0 001.725-1.315c.93-.931.824-1.277 1.724-2.072a3.681 3.681 0 011.706-.976 2.218 2.218 0 011.437.102c.604.3.856.924 1.343 2.16.21.542.391 1.095.542 1.656.107.286.254.555.436.798.193.205.362.431.504.675.112.306.125.641.038.957a2.182 2.182 0 01-1.136 1.584 2.148 2.148 0 01-1.937.028 19.438 19.438 0 00-2.972-.069c-.84.068-1.676.18-2.505.334a6.338 6.338 0 00-2.129.556c-.4.248-.783.52-1.15.815-1.364.97-1.637 1.076-1.966 1.051a1.272 1.272 0 01-1.063-.59z"
				fill="#BFBFBF"
			/>

			<rect x={34.9534} y={41.1074} width={11.3231} height={7.63079} rx={1.47693} fill="#8C8C8C" />

			<path
				d="M33.031 70.3a60.613 60.613 0 01-4.369-.533c-1.73-.268-2.623-.521-4.904-.93a120.421 120.421 0 00-5.076-.85h-.07a2.136 2.136 0 01-1.336-.78 2.162 2.162 0 01.18-2.89 2.12 2.12 0 011.422-.598c.141 0 .261.037.387.048 1.014.088 2.033.115 3.05.08a9.566 9.566 0 002.762-.337c.367-.12.77-.294 1.472-.496.479-.107.963-.182 1.452-.224 1.084-.1 3.357.163 6.189 1.084.77.144 1.465.563 1.953 1.18.49.618.74 1.393.705 2.18a3.268 3.268 0 01-.89 2.107c-.54.57-1.268.923-2.048.995-.292.013-.593-.014-.879-.036z"
				fill="#BFBFBF"
			/>

			<path
				d="M37.623 44.01a1.807 1.807 0 01-1.533 2.932 39.694 39.694 0 01-11.904-.548 2.251 2.251 0 01-1.658-.782 2.38 2.38 0 012.017-3.857 14.596 14.596 0 014.476.445c1.159.313 1.65.61 2.824.917 1.308.315 2.654.438 3.997.365a1.721 1.721 0 011.78.529z"
				fill="#8C8C8C"
			/>

			<mask
				id={maskA}
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x={36}
				y={40}
				width={10}
				height={9}
			>
				<path d="M45.102 40.828l.233 7.064-9.018.301-.233-7.063 9.018-.302z" fill="#fff" />
			</mask>

			<g mask={`url(#${maskA})`}>
				<path
					d="M43.454 46.783c-.029-.265-.309-.32-.58-.306l-1.69.167 2.733-.27c.216-.003.617-.068.648-.354.031-.287-.31-.453-.648-.433.521.032 1.005-.048 1.013-.383.004-.22-.182-.388-.475-.396l-3.224.177 2.752-.151c.291-.01.65-.112.641-.378-.009-.265-.277-.366-.56-.398 0 0-2.403-.131-2.869-.098-.5.014-1.624.044-1.756-.204.246-.133.492-.3.865-.402.395-.142.748-.698.681-1.034-.17-.472-.846.033-1.238.166-1.206.412-1.795.52-2.443.95-.438.28-.986.53-1.095 1.693.07 1.52.786 2.169 3.67 2.267.642.014 2.784-.17 3.172-.278.24-.067.421-.163.403-.335z"
					fill="#8C8C8C"
				/>
			</g>

			<path
				d="M25.889 44.933a2.48 2.48 0 01-1.156 1.503 2.46 2.46 0 01-1.878.24 2.583 2.583 0 01-1.246-.77 10.484 10.484 0 01-.399-.611 7.59 7.59 0 01-.644-1.36c-.338-.952-.48-1.277-.744-2.12-.484-.915-.393-1.117-1.404-2.9a24.116 24.116 0 01-1.678-3.603c-.106-.31-.203-.602-.296-.864l-.014-.03c-.113-.379-.221-.728-.298-.998a3.325 3.325 0 01.063-1.42 3.632 3.632 0 011.703-2.2 3.602 3.602 0 012.756-.338c.858.223 1.61.744 2.123 1.471l.016.034c.137.289.262.552.416.801a.071.071 0 00.02.043 12.24 12.24 0 011.028 3.258c.133.915.19 1.965.19 1.965.039.878-.003.997.047 1.77.02.748.122 1.492.302 2.22.18.716.457 1.406.822 2.049a2.43 2.43 0 01.27 1.86z"
				fill="#BFBFBF"
			/>

			<path
				d="M37.322 44.435a1.805 1.805 0 01-1.532 2.93 39.694 39.694 0 01-11.904-.548 2.251 2.251 0 01-1.658-.781 2.38 2.38 0 012.017-3.857 14.596 14.596 0 014.475.445c1.16.313 1.65.61 2.824.917 1.308.315 2.655.438 3.998.365a1.722 1.722 0 011.78.529z"
				fill="#BFBFBF"
			/>

			<mask
				id={maskB}
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x={35}
				y={41}
				width={11}
				height={8}
			>
				<path d="M44.801 41.252l.234 7.064-9.018.301-.234-7.064 9.018-.301z" fill="#fff" />
			</mask>

			<g mask={`url(#${maskB})`}>
				<path
					d="M43.154 47.206c-.029-.265-.309-.32-.58-.307l-1.691.168 2.734-.27c.216-.003.617-.068.648-.354.031-.287-.31-.453-.648-.433.521.032 1.005-.048 1.012-.383.005-.22-.182-.388-.474-.396l-3.225.176 2.752-.15c.292-.01.65-.112.642-.378-.01-.265-.277-.366-.56-.398 0 0-2.403-.131-2.869-.098-.5.014-1.625.044-1.756-.204.246-.133.492-.301.864-.402.395-.143.75-.698.682-1.035-.17-.471-.847.034-1.238.167-1.207.412-1.795.52-2.443.95-.438.28-.986.53-1.095 1.693.07 1.52.786 2.169 3.67 2.267.642.014 2.783-.17 3.171-.278.241-.067.422-.163.404-.335z"
					fill="#BFBFBF"
				/>
			</g>

			<g filter={`url(#${filter0})`}>
				<path d="M19.322 63.261l-6.277-3.2 5.415-2.215.862 5.415z" fill="#BFBFBF" />
			</g>

			<g filter={`url(#${filter1})`}>
				<path d="M25 65.45l-6.564-2.558 5.167-2.744L25 65.45z" fill="#BFBFBF" />
			</g>

			<g filter={`url(#${filter2})`}>
				<path d="M31.274 66.793l-6.864-1.59 4.72-3.457 2.144 5.047z" fill="#BFBFBF" />
			</g>

			<path
				d="M37.293 65.464c.355.756.394 1.621.108 2.408a3.191 3.191 0 01-1.637 1.791c-.555.27-.926-.032-1.54-.096a3.285 3.285 0 01-1.682-.675s-.01-.038-.054-.047l-.302-.31-.08-.066c-.736-.369-1.516-.643-2.214-1.083a15.187 15.187 0 00-3.989-1.697 77.148 77.148 0 01-7.932-2.856 30.364 30.364 0 01-4.8-2.638.5.5 0 01-.128-.074 6.674 6.674 0 01-.647-.47 5.647 5.647 0 01-1.626-1.997 6.003 6.003 0 01-.223-4.627 6.111 6.111 0 013.145-3.442 6.45 6.45 0 011.923-.579 7.059 7.059 0 014.336 1.017c2.423 1.27 3.766 2.545 6.526 4.908 3.832 3.273 3.658 2.898 5.442 4.575a55.97 55.97 0 015.001 5.347s.013.049.048.065c.129.169.238.352.325.546z"
				fill="#BFBFBF"
			/>

			<defs>
				<filter
					id={filter0}
					x={11.5678}
					y={56.3688}
					width={10.2153}
					height={9.35351}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={0.492309} dy={0.492309} />
					<feGaussianBlur stdDeviation={0.984618} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
					<feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
				</filter>

				<filter
					id={filter1}
					x={16.9589}
					y={58.6705}
					width={10.5032}
					height={9.24121}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={0.492309} dy={0.492309} />
					<feGaussianBlur stdDeviation={0.984618} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
					<feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
				</filter>

				<filter
					id={filter2}
					x={22.933}
					y={60.2692}
					width={10.8022}
					height={8.98535}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dx={0.492309} dy={0.492309} />
					<feGaussianBlur stdDeviation={0.984618} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
					<feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
				</filter>
			</defs>
		</svg>
	);
}
